module.exports = __webpack_public_path__ + "static/lukasz_gawronski-9e727ab2478379cde4dbd90fcd86e368.webp";